import { MutationTree, ActionTree, GetterTree } from 'vuex'
import {
  SET_COLLECTIONS,
  SET_CURRENT_TAB,
  SET_COLLECTIONS_IS_LOADING,
} from '../types'

import { getBase64Id } from '@/utils/general-utils'
import { cloneDeep } from 'lodash-es'
import { RootState } from '..'
import { CollectionList, getShopifyCollections } from '@/utils/shopify'

export interface CollectionsState {
  allCollections: CollectionList;
  isLoading: boolean;
  currentTab: number;
}

const state: CollectionsState = {
  allCollections: [],
  isLoading: true,
  currentTab: 0,
}

const getters: GetterTree<CollectionsState, RootState> = {
  currentTab: (state) => state.currentTab,
  tabTitles: (state) =>
    state.allCollections.map((collection) => collection.title),
  getCollectionId: (state) => (index: number) => state.allCollections[index]?.id ?? '',
  numberOfCollections: (state) => state.allCollections.length,
  isCollectionsLoaded: (state) => !state.isLoading,
}

const mutations: MutationTree<CollectionsState> = {
  [SET_COLLECTIONS](state, collections) {
    state.allCollections = collections
  },
  [SET_COLLECTIONS_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading
  },
  [SET_CURRENT_TAB](state, currentTab) {
    state.currentTab = currentTab
  },
}

const actions: ActionTree<CollectionsState, RootState> = {
  async loadCollections({ commit, rootGetters }) {
    const collections = await getShopifyCollections()
    const filteredCollections = collections
      .filter((collection) => collection.products.edges.length > 0)
      .filter((collection) => collection.handle.toLowerCase() !== 'kiosk')
      .filter((collection) => {
        if (rootGetters.tag) {
          return collection.products.edges.filter((productEdge) => {
            const product = productEdge.node
            return product.tags.find(tag => tag === rootGetters.tag)
          }).length !== 0 
        } else {
          return collection.products.edges.filter((productEdge) => {
            const product = productEdge.node
            return !product.tags.find(tag => tag === 'HIDE')
          }).length !== 0
        }
      })
      .map((collection) => {
        const newCollection = cloneDeep(collection)
        newCollection.id = getBase64Id(collection.id)
        return collection
      })
    commit(SET_COLLECTIONS, filteredCollections)
    commit(SET_COLLECTIONS_IS_LOADING, false)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
